module.exports = __webpack_public_path__ + "static/media/react-api-redux-dashboard.b2082fd7.png";